import { initMap, equalCols } from '../functions';

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

// type one text in the typwriter
// keeps calling itself until the text is finished
function typeWriter(elemtId, text, i, fnCallback) {
	// chekc if text isn't finished yet
	if (i < (text.length)) {
		// add next character to h1
		document.querySelector("." + elemtId).innerHTML = text.substring(0, i+1) +'<span class="caret" aria-hidden="true"></span>';

		// wait for a while and call this function again for next character
		setTimeout(function() {
			typeWriter(elemtId, text, i + 1, fnCallback)
		}, 100);
	}
	// text finished, call callback if there is a callback function
	else if (typeof fnCallback == 'function') {
		// call callback after timeout
		setTimeout(fnCallback, 700);
	}
}

$(document).ready(function(){

	$(document).on('click', '.promotion-configurator-btn', function(e) {
		let id = $(this).data('id');
		if (!id || id == '' || id == null) {
			console.error('Invalid ID!');
			return false;
		}

		var values = '_token=' + $("meta[name='csrf-token']").attr("content");
		values += '&id=' + id;
		$.ajax({
			type: "POST",
			url: baseURL + "/auto-dealer/promotion-configurator-visit",
			data: values,
			success: function(response) {
				if (response.status == 1) {

				}
			},
			error(error) {

			}
		});
	});

	$(document).on('click', '.model-configurator-btn', function(e) {
		let id = $(this).data('id');
		if (!id || id == '' || id == null) {
			console.error('Invalid ID!');
			return false;
		}

		var values = '_token=' + $("meta[name='csrf-token']").attr("content");
		values += '&id=' + id;
		$.ajax({
			type: "POST",
			url: baseURL + "/auto-dealer/model-configurator-visit",
			data: values,
			success: function(response) {
				if (response.status == 1) {

				}
			},
			error(error) {

			}
		});
	});

    // window.onload = function () {
    //     $('.preloader-wrapper').fadeOut(500, function(){
    //         $('.preloader-wrapper').remove();
    //     });
    // }
	$('.typeWriter').each(function() {
		if ($(this).isInViewport()) {
			if ($(this).data('run') == '0') {
				var id = $(this).data('id');
				var text = $(this).html();
				typeWriter('typeWriter-' + id, text, 0);
				$(this).data('run', 1);
			}
		}
	});
	$(window).on('resize scroll', function() {
		$('.typeWriter').each(function() {
			if ($(this).isInViewport()) {
				if ($(this).data('run') == '0') {
					var id = $(this).data('id');
					var text = $(this).html();
					typeWriter('typeWriter-' + id, text, 0);
					$(this).data('run', 1);
				}
			}
		});
	});

	if (  $( ".swiper-recom" ).length  ) {
		var swiperRecomandations = new Swiper('.swiper-recom', {
			slidesPerView: 1,
			spaceBetween: 20,
			// loop: true,
			autoplay: {
				delay: 6000,
			},
			navigation: {
				nextEl: '.swiper-recom-next',
				prevEl: '.swiper-recom-prev',
			},
			breakpoints: {
				768: {
				  slidesPerView: 'auto',
				  spaceBetween: 50,
				  freeMode: true,
				},
			}
		});
	}


	$('.slick-hero').slick({
		autoplay: true
		// arrows: false,
	});

	$(window).scroll(function() {
		var scroll = $(window).scrollTop();

		if (scroll >= 200) {
			$(".navbar-dark").addClass("active");
		} else {
			$(".navbar-dark").removeClass("active");
		}
	});


	if($('.boxes-rabla-eq-height').length > 1) {
		equalCols('.boxes-rabla-eq-height');
	}

	$(document).on('click', '.floating-menu-btn', function(e) {
		$('.floating-menu-container').toggleClass('is-open');
	});
	$(document).on('click', '.close-floating-menu', function(e) {
		$('.floating-menu-container').removeClass('is-open');
	});

	$(".slider-home").slick({
        infinite: true,
        speed: 300,
        fade: true,
        cssEase: 'linear',
		autoplay: true,
  		autoplaySpeed: 5000,
    });
	$('.slider-home').on('afterChange', function(event, slick, currentSlide){
		$('.slider-home').find('.curent').html(currentSlide+1);
	});

	$(".nav-footer .item").click(function(){
		$(".toggle-showroom-footer").parent().removeClass('toggled fade');
		$(".toggle-showroom-footer").css('display', 'none');
        $(this).find($(".toggle-showroom-footer")).slideToggle("opened");
        $(this).toggleClass("fade");
        $(this).toggleClass("toggled");
    });

    $(".nav-footer-mobile .nav-footer .nav-footer-head-mobile").click(function(){
        $(this).parent().find($(".mobile-open")).slideToggle("displayed");
        $(this).parent().find($(".head")).toggleClass("opened");
    });

    $(".scrollTo").on('click', function(e) {
		e.preventDefault();
		var target = $(this).attr('href');

		$('html, body').animate({
			scrollTop: ($(target).offset().top)
		}, 0, function() {
			window.location.hash = target;
		});

	});

    $(".scrollToMobile").on('click', function(e) {
		e.preventDefault();
		var target = $(this).attr('href');

		// $(".meniu-mobile").toggleClass("open");
		// $(".layer-mobile").hide();
		$(".header").removeClass('mobile-meniu-open');
		$("body").css("overflow","scroll");

		window.scrollTo(0, ($(target).offset().top - 80));
		/*$('html, body').animate({
			scrollTop: ($(target).offset().top - 80)
		}, 1000, function() {
			//console.log($(target).offset().top);
			//console.log($(target).offset().top-200);
			//window.location.hash = target;
		});*/

	});

	(function($, window) {
        var adjustAnchor = function() {

            var $anchor = $(':target'),
                    fixedElementHeight = 80;

            if ($anchor.length > 0) {
                // $('html, body')
                //     .stop()
                //     .animate({
                //         scrollTop: $anchor.offset().top - fixedElementHeight
                //     }, 200);
				window.scrollTo(0, $anchor.offset().top - fixedElementHeight);


            }

        };

        $(window).on('hashchange load', function() {
			if($(window).width() < 1366) {
				adjustAnchor();
			}
        });

    })(jQuery, window);

	$(".toggle-filters-vehicles").click(function(){
		$(".filters-mobile").toggleClass("opened");
	})

	$('.slider-for').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.slider-nav'
	});
	$('.slider-nav').slick({
		slidesToShow: 6,
		slidesToScroll: 1,
		asNavFor: '.slider-for',
		dots: false,
		arrows: false,
		centerMode: true,
		focusOnSelect: true
	});

	$('.promotii-masini-slider').slick({
		infinite: false,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});

	var mobileMap = null;
	$(".hamburger").click(function() {
		//$(".header").addClass('mobile-menu-opening');
		$(".header").toggleClass("mobile-meniu-open");
		// $(".meniu-mobile").toggleClass("open");
		// $(".layer-mobile").show();
		// $("body").css("overflow","hidden");
		//
		// if (mobileMap == null) {
		// 	mobileMap = true;
		// 	initMap('mobile-menu-map');
		// }
	});

	if (document.querySelector('.header')) {
		document.querySelector('.header').addEventListener('transitionrun', () => {
			$(".header").addClass("mobile-menu-opening");
		});
		document.querySelector('.header').addEventListener('transitionend', () => {
			$(".header").removeClass("mobile-menu-opening");
		});
	}

	$(".close-meniu-mobile").click(function() {
		$(".meniu-mobile").toggleClass("open");
		$(".layer-mobile").hide();
		$("body").css("overflow","scroll");
	});
	var wow = new WOW({
			boxClass:     'wow',      // animated element css class (default is wow)
			animateClass: 'animated', // animation css class (default is animated)
			offset:       0,          // distance to the element when triggering the animation (default is 0)
			mobile:       true,       // trigger animations on mobile devices (default is true)
			live:         true,       // act on asynchronously loaded content (default is true)
			callback:     function(box) {
			// the callback is fired every time an animation is started
			// the argument that is passed in is the DOM node being animated
		},
		scrollContainer: null,    // optional scroll container selector, otherwise use window,
		resetAnimation: true,     // reset animation on end (default is true)
	});
	wow.init();

	$(window).scroll(function() {
		if ($(window).width() < 1025) {
			if ($(document).scrollTop() > 100) {
				$('.header').addClass('header-fixed');
			} else {
				$('.header').removeClass('header-fixed');
			}
		} else {
			$('.header').removeClass('header-fixed');
		}

		if ($(document).scrollTop() > 100) {
			$('#go-to-top').addClass('active');
		} else {
			$('#go-to-top').removeClass('active');
		}
	});

	$(document).on('click', '#go-to-top', function(e) {
		e.preventDefault();

		$('html, body').stop().animate({
							        	scrollTop: 0
								    }, 200);
	});

	$( ".dropdown-element--box" ).mouseenter(function() {
		$(this).css('display', 'block');
	});
	$(".dropdown-element--title").hover(function(){
		$(this).siblings().removeClass('active');
		$(this).addClass('active');
		let dropElement = document.getElementById($(this).attr( "data-drop-id" ));
		$(dropElement).siblings().removeClass('active');
		$(dropElement).addClass('active');
	});

	

	$(".toggle-sublink").click(function() {
		$(this).toggleClass('active');
		$(this).siblings('ul').slideToggle();
	});
	$(".toggle-sublink-link").click(function() {
		$(this).toggleClass('active');
		$(this).siblings('ul').slideToggle();
	});

	// PROGRESS WIP
	const contentSection = document.querySelector('#progress-box');
	const progressIndicator = document.querySelector('#section-progress--value');
	const progressSections = document.querySelectorAll('section.template-step .section-counter')
	const preogressOptions = {
		root: null, // Use the viewport as the root
		rootMargin: '-30px',
		threshold: .5, // When at least 50% of the section is visible
	};
	//console.log(progressSections);
	function updateProgressIndicator() {
		const totalScrollHeight = contentSection.offsetHeight;
		const scrolledAmount = window.scrollY - contentSection.offsetTop;
		const progress = (scrolledAmount / totalScrollHeight) * 100;
		// console.log(contentSection.scrollHeight, contentSection.clientHeight, progress);
		progressIndicator.style.height = 15 + progress + '%';
	}
	function callback(entries, observer) {
		entries.forEach(entry => {
		  const targetSection = entry.target;
	
		  if (entry.isIntersecting) {
			targetSection.classList.add('active');
		  } else {
			targetSection.classList.remove('active');
		  }
		});
	}
	const observer = new IntersectionObserver(callback, preogressOptions);
	if ( $( contentSection ).length ) {
		window.addEventListener('scroll', updateProgressIndicator);
		// Observe each section
		progressSections.forEach(section => {
			observer.observe(section);
		});
	}
	

	
	// PROGRESS WIP

	// PARTNER LOGOS
	// PARTNER LOGOS


});

$(document).ready(function () {
	const swiper = new Swiper('.slider-car-right', {
	loop: true,
	autoplay: {
		delay: 3000,
	},
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	}
	});
});



$(document).ready(function () {
	$('.filter-box').on('click', function (e) {
		// Prevent toggle if clicking on .filter-content or any of its descendants
		if ($(e.target).closest('.filter-content').length) {
			return;
		}
		
		e.preventDefault(); // optional

		$(this).toggleClass('active');

		const content = $(this).find('.filter-content');

		if (content.css('display') === 'none') {
			content.css('display', 'block');
		} else {
			content.css('display', 'none');
		}
	});
});

$(document).ready(function () {
	$('[data-bs-toggle="tooltip"]').each(function () {
		new bootstrap.Tooltip(this);
	});
});

$(document).ready(function () {
	$('.filter-btn-mobile').click(function (e) {
		e.preventDefault();
		$('.filters').addClass('open');
		$('body').css('overflow', 'hidden');
	});

	$('.close-filters-mobile').click(function (e) {
		e.preventDefault();
		$('.filters').removeClass('open');
		$('body').css('overflow', '');
	});
});


// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js